export default {
  information: 'MAIN_GETTERS_INFORMATION',
  informationTimeoutChecker: 'MAIN_GETTERS_INFORMATION_TIMEOUT_CHECKER'
}
